if (!customElements.get('adev-review-carousel-v1')) {
    customElements.define('adev-review-carousel-v1', class adevReviewCarouselV1 extends HTMLElement {
        constructor() {
            super();
        }

        initSlider() {
            const carouselEl = this.querySelector('[data-adev-review-carousel-v1="carousel"]');

            this.slider = new Flickity(carouselEl, {
                cellAlign: 'center',
                contain: true,
                pageDots: true,
                prevNextButtons: false,
                groupCells: false, // shows one card at a time but keeps others visible
                wrapAround: true,  // infinite loop
                draggable: true,
                freeScroll: false,
                adaptiveHeight: false,
                on: {
                    ready: function() {
                        this.slider.classList.add("flickity-resize");
                    }
                }
            });

            window.addEventListener('resize', () => {
                if (this.slider) {
                    console.log('refs');
                    
                    this.slider.resize();
                    this.slider.reposition();
                }
            });
        }

        destroySlider(){
            if (this.slider) {
                this.slider.destroy();
            }
        }

        shopifyCustomizerInit(){
            if (Shopify.designMode) {
                document.addEventListener('shopify:block:select', (e) => {
                    const block = e.detail;

                    const blockId = block.blockId;
                    const sectionId = block.sectionId;

                    const blockElement = this.querySelector(`[data-id="${blockId}"]`);
                    
                    if (blockElement) {
                        const index = blockElement.getAttribute('data-index');
                        this.slider.select(index);
                    }
                });
            }
        }
        
        connectedCallback() {
            this.initSlider();
            this.shopifyCustomizerInit();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

    });
}